<template>
    <div class="business-content-main" v-loading="saveLoading" element-loading-spinner="none">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="tab-item-ctn">
            <div class="search-ctn">
                <div class="search-ctn-right">
                    <div class="search-name">客户名称</div>
                    <el-select
                        class="search-item"
                        size="small"
                        v-model="searchData.Name"
                        remote
                        filterable
                        allow-create
                        clearable
                        placeholder="请输入客户名称"
                        :remote-method="searchCustom"
                        v-select-scroll-more="searchCustomLoad"
                        @visible-change="customerVisibleChange($event)"
                        popper-class="my-select"
                    >
                        <el-option v-for="item in cusOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName">
                            <div class="name">
                                {{ item.EntpCusName }}
                                <span v-if="item.CallNum" class="phone">{{ ` ( 电话：${item.CallNum} )` }}</span>
                            </div>
                        </el-option>
                    </el-select>
                    <div class="search-name">标签</div>
                    <el-select class="search-item" size="small" filterable clearable multiple collapse-tags v-model="searchData.Tags" @visible-change="cusTagVisibleChange($event)">
                        <el-option v-for="optionItem in cusTagsList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value"></el-option>
                    </el-select>
                    <div class="search-name">业务员</div>
                    <el-select class="search-item" size="small" filterable clearable multiple collapse-tags v-model="searchData.SIds" @visible-change="cusSiVisibleChange($event)">
                        <el-option v-for="item in cusSIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                    </el-select>                    
                    <div class="search-name">提交日期</div>
                    <el-date-picker
                        v-model="datetime3"
                        size="small"
                        class="search-item"
                        type="daterange"
                        align="right"
                        style="width: 235px"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        @change="onDate3TimeSelect"
                    ></el-date-picker>

                    <div class="search-name">
                        <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleCurrentChange(1)">查询（Enter）</el-button>
                        <el-button size="small" class="search-btn btn-primary" @click="showSearchDialog">更多条件（F2）</el-button>
                        <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                        <el-button size="small" class="search-btn btn-primary" v-if="permission.export" @click="exportData">
                            <i class="fa fa-file-excel-o"></i>
                            {{ permission.export }}</el-button
                        >
                    </div>
                </div>
            </div>
            <div>
                <el-card class="box-card">
                    <div class="data-count">
                        <div class="data-item">
                            <p>销售总额</p>
                            <p>￥{{ saleStatData.orderTotal }}</p>
                        </div>
                        <div class="data-item">
                            <p>订单总数</p>
                            <p>{{ saleStatData.orderCount }}</p>
                        </div>
                        <div class="data-item">
                            <p>商品总数</p>
                            <p>{{ saleStatData.goodsTotal }}</p>
                        </div>
                        <div class="data-item">
                            <p>运费总计</p>
                            <p>{{ saleStatData.transTotal }}</p>
                        </div>
                        <div class="data-item">
                            <p>
                                <el-tooltip effect="dark" placement="bottom">
                                    <div slot="content">（跟单退货/无单退货的退款额） + （明细退货：退货价 * 退货数量）</div>
                                    <span>
                                        <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                                    </span> </el-tooltip
                                >退货总额
                            </p>
                            <p>￥{{ saleStatData.returnTotal }}</p>
                        </div>
                        <div class="data-item">
                            <p>退货总数</p>
                            <p>{{ saleStatData.returnGoodsTotal }}</p>
                        </div>
                        <div class="data-item">
                            <p>优惠总额</p>
                            <p>{{ saleStatData.discountTotal }}</p>
                        </div>
                        <div class="data-item">
                            <p>
                                <el-tooltip effect="dark" placement="bottom">
                                    <div slot="content">实际销售额 = 销售总额 - 销售退货总额</div>
                                    <span>
                                        <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                                    </span> </el-tooltip
                                >实际销售额
                            </p>
                            <p>￥{{ saleStatData.acAmount }}</p>
                        </div>
                        <div class="data-item">
                            <p>总成本</p>
                            <p style="color: red; font-size: 16px">￥{{ saleStatData.coseTotal }}</p>
                        </div>
                        <div class="data-item">
                            <p>总利润</p>
                            <p style="color: green; font-size: 16px" v-if="saleStatData.profitTotal > 0">￥{{ saleStatData.profitTotal }}</p>
                            <p style="color: red; font-size: 16px" v-else>￥{{ saleStatData.profitTotal }}</p>
                        </div>
                        <div class="data-item border-right-none">
                            <p>毛利率</p>
                            <p>
                                {{ saleStatData.profitTotal | profitPercentage(saleStatData.orderTotal - saleStatData.returnTotal) }}
                            </p>
                        </div>
                    </div>
                </el-card>
            </div>
            <div class="table-ctn">
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :data="tableData"
                    border
                    style="width: 100%"
                    :default-sort="{ prop: 'BuyTotalAmount', order: 'descending' }"
                    @sort-change="sortChange"
                >
                    <el-table-column show-overflow-tooltip width="55px" type="index" :index="indexMethod" label="排名"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="80px" prop="Tags" label="标签"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="120px" prop="Name" label="客户名称"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="120px" prop="Zone" label="地区"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable="custom" width="120" prop="BuyTotalAmount" label="订单总额"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable="custom" width="105" prop="OrderCount" label="订单总数"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable="custom" width="105" prop="GoodsCount" label="商品总数"></el-table-column>
                    <!-- <el-table-column show-overflow-tooltip sortable="custom" min-width="110" prop="GoodsCateCount" label="商品种类"></el-table-column> -->
                    <el-table-column show-overflow-tooltip sortable="custom" width="130" prop="ReturnTotalAmount" label="销售退货总额"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable="custom" width="140" prop="ReturnGoodsCount" label="销售退货数(件)"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable="custom" min-width="100" prop="RealSaleTotalAmount" label="实际销售额"> </el-table-column>
                    <el-table-column show-overflow-tooltip sortable="custom" min-width="100" prop="TotalCost" label="总成本"> </el-table-column>
                    <el-table-column show-overflow-tooltip sortable="custom" min-width="100" prop="TotalProfit" label="总利润"> </el-table-column>
                    <el-table-column show-overflow-tooltip width="90" prop="" label="毛利率">
                        <template slot-scope="scope">{{ scope.row.TotalProfit | profitPercentage(scope.row.RealSaleTotalAmount) }}</template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip width="100" label="最新跟进人">
                        <template slot-scope="scope">{{ scope.row.Follower }}</template>
                    </el-table-column>
                    <el-table-column label="其他统计" width="85px">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <el-button title="销售数据" size="mini" type="text" @click="showSaleStat(scope.row)">销售数据</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>
            <el-dialog :close-on-click-modal="false" :title="SaleDialogTitle" :visible.sync="showSaleStatDialog" :append-to-body="true" width="1300px">
                <div v-if="showSaleStatDialog">
                    <saleStat
                        @closeDialog="closeSaleStatDialog"
                        :EntpCusId="this.entpCusId"
                        :StartDate="this.searchData.StartDate"
                        :EndDate="this.searchData.EndDate"
                    ></saleStat>
                </div>
            </el-dialog>

            <el-progress type="circle" :percentage="percentage" class="saveProgress" :class="{ hide: !saveLoading }"></el-progress>
            <div style="z-index: 2001" class="exportmsg" v-if="showExportMsg">
                <span>数据已经准备好，正在生成Excel表格，可能耗时1-5min，请耐心等候……</span>
                <span>您也可以打开新的窗口进行其他的操作</span>
            </div>
            <el-dialog
                :close-on-click-modal="false"
                title="数据搜索"
                :visible.sync="dialogSearchVisible"
                width="400px"
                append-to-body
                v-dialog-drag
                lock-scroll
                :modal="false"
                id="search-custStatic-dialog"
                custom-class="search-item-dialog"
                style="margin-left: -170px"
            >
                <div class="dialog-content" v-if="dialogSearchVisible">
                    <el-form ref="form" label-position="left" label-width="70px">
                        <el-form-item label="客户名称">
                            <el-select
                                ref="search_cus"
                                style="width: 100%"
                                size="small"
                                v-model="searchData.Name"
                                remote
                                filterable
                                allow-create
                                clearable
                                placeholder="请输入客户名称"
                                :remote-method="searchCustom"
                                v-select-scroll-more="searchCustomLoad"
                                @visible-change="customerVisibleChange($event)"
                                popper-class="my-select"
                            >
                                <el-option v-for="item in cusOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName">
                                    <div class="name">
                                        {{ item.EntpCusName }}
                                        <span v-if="item.CallNum" class="phone">
                                            {{ ` ( 电话：${item.CallNum} )` }}
                                        </span>
                                    </div>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="标签">
                            <el-select style="width: 100%" size="small" filterable clearable multiple v-model="searchData.Tags" @visible-change="cusTagVisibleChange($event)">
                                <el-option v-for="optionItem in cusTagsList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="业务员">
                            <el-select
                                v-model="searchData.SIds"
                                size="small"
                                style="width: 100%"
                                filterable
                                placeholder="请选择"
                                multiple
                                clearable
                                @visible-change="cusSiVisibleChange($event)"
                            >
                                <el-option v-for="item in cusSIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="创建人">
                            <el-select style="width: 100%" size="small" v-model="searchData.CreatorId" clearable @visible-change="cusSiVisibleChange($event)">
                                <el-option v-for="item in cusSIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="国家">
                            <el-select
                                size="small"
                                style="width: 100%"
                                v-model="searchData.Country"
                                class="search-item"
                                filterable
                                clearable
                                value-key="CountryName"
                                @change="countryChange"
                                @visible-change="countryVisibleChange($event)"
                                placeholder="请选择"
                            >
                                <el-option v-for="item in countryList" :key="item.CountryId" :label="item.CountryName" :value="item"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="省">
                            <el-select
                                size="small"
                                style="width: 100%"
                                v-model="searchData.Province"
                                class="search-item"
                                filterable
                                clearable
                                value-key="ProvinceName"
                                @change="provinceChange"
                                placeholder="请选择省"
                            >
                                <el-option v-for="item in provinceList" :key="item.ProvinceId" :label="item.ProvinceName" :value="item"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="市">
                            <el-select
                                size="small"
                                style="width: 100%"
                                v-model="searchData.City"
                                class="search-item"
                                filterable
                                clearable
                                value-key="CityName"
                                @change="cityChange"
                                placeholder="请选择市"
                            >
                                <el-option v-for="item in cityList" :key="item.CityId" :label="item.CityName" :value="item"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="区">
                            <el-select
                                size="small"
                                style="width: 100%"
                                v-model="searchData.District"
                                class="search-item"
                                filterable
                                clearable
                                value-key="DistrictName"
                                placeholder="请选择区"
                            >
                                <el-option v-for="item in zoneList" :key="item.DistrictId" :label="item.DistrictName" :value="item"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="创建日期">
                            <el-date-picker
                                size="small"
                                style="width: 100%"
                                v-model="dateTimes"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                @change="onDateTimeSelect"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="提交日期">
                            <el-date-picker
                                size="small"
                                style="width: 100%"
                                v-model="datetime3"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                :picker-options="pickerOptions"
                                @change="onDate3TimeSelect"
                            ></el-date-picker>
                        </el-form-item>
                    </el-form>
                    <div class="dialog-footer">
                        <el-button class="btn-primary" size="small" @click="handleCurrentChange(1)">查询（Enter）</el-button>
                        <el-button size="small" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                        <el-button size="small" @click="closeSearchDialog_N">关闭（Esc）</el-button>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import saleStat from '@/components/business/revenue/cusSaleStat';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        breadcrumb,
        saleStat
    },
    data() {
        return {
            dateTimes: [],
            datetime3: [],
            permission: {},
            showSaleStatDialog: false,
            SaleDialogTitle: '',
            entpCusId: '',
            cusTagsList: [],
            cusSIdList: [],
            searchData: {
                Name: '',
                Tag: '',
                Tags:[],
                Zone: '',
                SId: '',
                SIds: [],
                CreatorId: '',
                SortProp: '',
                SortType: '',
                StartDate: '',
                EndDate: '',
                CStartDate: '',
                CEndDate: '',
                page: 1,
                limit: 15,
                Country: {},
                Province: {},
                City: {},
                District: {}
            },
            saleStatData: {
                orderTotal: 0,
                orderCount: 0,
                goodsTotal: 0,
                transTotal: 0,
                returnTotal: 0,
                returnGoodsTotal: 0,
                coseTotal: 0,
                profitTotal: 0,
                acAmount: 0,
                discountTotal:0
            },
            tableData: [],
            tableDataLength: 0,
            // 用于客户名称列表，分页搜索
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            saveLoading: false,
            percentage: 0, //进度
            currtPage: 1, //页面，表示保存到第几页,
            saveCount: 0, //已保存数
            showExportMsg: false,
            exportTotalCount: 0,
            dialogSearchVisible: false,
            countryList: [],
            provinceList: [],
            cityList: [],
            zoneList: []
        };
    },
    filters: {
        profitPercentage(val1, val2) {
            if (val1 && val2) {
                return Number((val1 / val2) * 100).toFixed(2) * 1 + '%';
            } else {
                return '0%';
            }
        }
    },
    activated() {
        document.addEventListener('keydown', this.handleKeyEvent);
    },
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        if (this.dialogSearchVisible) this.dialogSearchVisible = false;
        next();
    },
    created() {
        //当前设定的日期时间
        let d = new Date();
        let year1, month1, day1;
        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date1 = new Date(year1, month1, day1, 0);
        this.datetime3.push(date1);
        //前一天设定的日期时间
        let year2, month2, day2;
        d.setTime(d.getTime());
        [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date2 = new Date(year2, month2, day2, 0);
        this.datetime3.unshift(date2);

        this.searchData.CStartDate = date2;
        this.searchData.CEndDate = date1;
        this.getCountryList();
    },
    mounted() {
        this.permission = this.$util.getPermission('CustStatic');
        // this.$util.setEnterEvent(this, this.$route.fullPath);
        this.getTableData();
    },
    methods: {
        handleKeyEvent(e) {
            let that = this;
            let key = window.event.keyCode;
            if (that.saveLoading) return;
            //F2
            if (key === 113) {
                e.preventDefault();
                this.dialogSearchVisible = true;
                return;
            }
            //Enter
            if (key === 13) {
                e.preventDefault();
                that.handleCurrentChange(1);
            }
            //ESC
            if (key === 27) {
                e.preventDefault();
                this.dialogSearchVisible = false;
            }
        },
        // 客户名称列表，搜索
        async searchCustom(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            const data = await this.$util.searchCustomerNoAuth(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustom();
        },
        indexMethod(index) {
            return index + 1 + (this.searchData.page - 1) * this.searchData.limit;
        },
        // 重置表单
        resetSearch() {
            this.searchData = {
                Name: '',
                Tag: '',
                Tags:[],
                Zone: '',
                SId: '',
                SIds:[],
                SortProp: '',
                SortType: '',
                StartDate: '',
                EndDate: '',
                CStartDate: '',
                CEndDate: '',
                page: 1,
                limit: this.commonPageSize,
                Country: {},
                Province: {},
                City: {},
                District: {}
            };
            this.dateTimes = [];
            this.datetime3 = [];
            // this.searchCustom('');
        },
        // 获取数据
        getTableData() {
            let that = this;
            let CountryName = that.searchData.Country && that.searchData.Country.CountryName ? that.searchData.Country.CountryName : '';
            let ProvinceName = that.searchData.Province && that.searchData.Province.ProvinceName ? that.searchData.Province.ProvinceName : '';
            let CityName = that.searchData.City && that.searchData.City.CityName ? that.searchData.City.CityName : '';
            let DistrictName = that.searchData.District && that.searchData.District.DistrictName ? that.searchData.District.DistrictName : '';
            that.searchData.Zone = CountryName + ProvinceName + CityName + DistrictName;
            let tags = "";
            for(var i = 0;i < that.searchData.Tags.length;i++){
                tags = tags + that.searchData.Tags[i] + ",";
            }
            that.searchData.Tag = tags;
            let sids = "";
            for(var j = 0;j < that.searchData.SIds.length;j++){
                sids = sids + that.searchData.SIds[j] + ",";
            }
            that.searchData.SId = sids;
            that.$util
                .axiosGet({
                    url: '/api/DataStatistics/CustomerStatistics',
                    data: that.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (res.errcode != 201) {
                        if (!data) data = [];
                        that.tableData = data.DataList;

                        if (that.searchData.page == 1) {
                            that.saleStatData = {
                                orderTotal: data.OrderTotal,
                                orderCount: data.OrderCount,
                                goodsTotal: data.GoodsTotal,
                                transTotal: data.TransTotal,
                                returnTotal: data.ReturnTotal,
                                returnGoodsTotal: data.ReturnGoodsTotal,
                                coseTotal: data.CoseTotal,
                                profitTotal: data.ProfitTotal,
                                acAmount: (data.OrderTotal - data.ReturnTotal).toFixed(2),
                                discountTotal: data.DiscountTotal.toFixed(2)
                            };
                            that.tableDataLength = res.count;
                        }
                    }
                })
                .catch(() => {});
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.getTableData();
        },
        searchCusTags() {
            let url = '/api/EntpCustomers/GetEnterpriseCustomerTagList';
            this.loading = true;
            this.$util
                .axiosGet({
                    url: url,
                    hideLoading: true
                })
                .then(res => {
                    this.cusTagsList = res.data;
                });
        },
        cusTagVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.cusTagsList.length == 0) that.searchCusTags();
            }
        },
        getCusSIdList() {
            this.$util.getSalemanList().then(data => {
                this.cusSIdList = data;
            });
        },
        //当业务员下拉框出现时触发
        cusSiVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.cusSIdList.length == 0) that.getCusSIdList();
            }
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        showSaleStat(row) {
            if (row) {
                this.SaleDialogTitle = '【 ' + row.Name + ' 】销售数据';
                this.entpCusId = row.EntpCusId;
                this.showSaleStatDialog = true;
            }
        },
        closeSaleStatDialog() {
            this.showSaleStatDialog = false;
        },
        onDateTimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        onDate3TimeSelect(val) {
            if (val != null) {
                this.searchData.CStartDate = val[0];
                this.searchData.CEndDate = val[1];
            } else {
                this.searchData.CStartDate = '';
                this.searchData.CEndDate = '';
            }
        },
        customerVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.cusOptions.length <= 1) that.searchCustomLoad();
            }
        },
        exportData() {
            let that = this;
            if (that.tableData.length == 0) {
                that.$util.warningMsg('请筛选数据');
                return;
            }
            that.saveLoading = true;
            // let saveLimit = 100;
            // if (that.tableDataLength < saveLimit) saveLimit = that.tableDataLength;
            let saveLimit = that.tableDataLength;
            let tags = "";
            for(var i = 0;i < that.searchData.Tags.length;i++){
                tags = tags + that.searchData.Tags[i] + ",";
            }
            that.searchData.Tag = tags;
            let sids = "";
            for(var j = 0;j < that.searchData.SIds.length;j++){
                sids = sids + that.searchData.SIds[j] + ",";
            }
            that.searchData.SId = sids;
            let reqData = { ...that.searchData };
            reqData.limit = saveLimit;
            reqData.page = that.currtPage;

            that.$util
                .axiosGet({
                    url: '/api/DataStatistics/GetCustStatisticsToExport',
                    data: reqData,
                    hideLoading: true
                })
                .then(resp => {
                    let data = resp.data;
                    if (that.currtPage == 1) {
                        if (data.totalCount == 0) {
                            that.percentage = 0;
                            that.saveCount = 0;
                            that.currtPage = 1;
                            that.exportTotalCount = 0;
                            that.saveLoading = false;
                            that.showExportMsg = false;
                            that.$util.warningMsg('没有可导出的数据');
                            return;
                        }
                        that.exportTotalCount = data.totalCount;
                    }
                    // that.saveCount += saveLimit;
                    that.saveCount += data.count;
                    let num = parseFloat(that.saveCount);
                    let total = parseFloat(that.exportTotalCount);
                    that.percentage = total <= 0 ? 0 : Math.round(Math.round((num / total) * 10000) / 100.0);
                    that.percentage = that.percentage > 100 ? 100 : that.percentage;
                    if (that.exportTotalCount <= that.saveCount) {
                        that.showExportMsg = true;
                        that.$util
                            .exportFile({
                                url: '/api/DataStatistics/ExportCustStatistics'
                            })
                            .then(res => {
                                that.percentage = 0;
                                that.saveCount = 0;
                                that.currtPage = 1;
                                that.exportTotalCount = 0;
                                that.saveLoading = false;
                                that.showExportMsg = false;
                                that.$util.successMsg('导出成功');
                            });
                    } else {
                        that.currtPage++;
                        that.exportData();
                    }
                })
                .catch(() => {
                    that.percentage = 0;
                    that.saveCount = 0;
                    that.currtPage = 1;
                    that.exportTotalCount = 0;
                    that.saveLoading = false;
                    that.showExportMsg = false;
                });
        },
        showSearchDialog() {
            this.dialogSearchVisible = true;
        },
        closeSearchDialog_N() {
            this.dialogSearchVisible = false;
        },
        countryChange(value) {
            this.searchData.Province = {};
            this.searchData.City = {};
            this.searchData.District = {};
            this.cityList = [];
            this.zoneList = [];
            if (value && value.CountryId) this.getProvinceList(value.CountryId);
        },
        provinceChange(value) {
            this.searchData.City = {};
            this.searchData.District = {};
            if (value && value.ProvinceId) this.getCityList(value.ProvinceId);
        },
        cityChange(value) {
            this.searchData.District = {};
            if (value && value.CityId) this.getZoneList(value.CityId);
        },
        countryVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.countryList.length <= 0) {
                    that.getCountryList();
                }
                that.searchData.Country = {
                    CallCode: '86',
                    CountryId: '54416925-01EE-40A2-A536-DA142C06F5E8',
                    CountryName: '中国'
                };
                that.getProvinceList(that.searchData.Country.CountryId);
            }
        },
        getCountryList() {
            return new Promise((resolve, reject) => {
                let that = this;
                this.$util
                    .axiosGet({
                        url: '/api/Region/GetCountryList',
                        hideLoading: true
                    })
                    .then(res => {
                        that.countryList = res.data;
                        resolve();
                    })
                    .catch(() => {});
            });
        },
        getProvinceList(CountryId) {
            return new Promise((resolve, reject) => {
                this.$util
                    .axiosGet({
                        url: '/api/Region/GetProvinceList',
                        data: {
                            CountryId: CountryId
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        this.provinceList = res.data;
                        resolve();
                    })
                    .catch(() => {});
            });
        },
        getCityList(ProvinceId) {
            return new Promise((resolve, reject) => {
                this.$util
                    .axiosGet({
                        url: '/api/Region/GetCityList',
                        data: {
                            ProvinceId: ProvinceId
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        this.cityList = res.data;
                        resolve();
                    })
                    .catch(() => {});
            });
        },
        getZoneList(CityId) {
            this.$util
                .axiosGet({
                    url: '/api/Region/GetDistrictList',
                    data: {
                        CityId: CityId
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.zoneList = res.data;
                })
                .catch(() => {});
        }
    }
};
</script>
<style lang="less" scoped>
.data-count {
    padding: 5px;
    display: flex;
    .data-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 12.5%;
        border-right: 1px solid @border4Color;
        > p:nth-child(1) {
            margin-bottom: 5px;
        }
    }
}
.saveProgress {
    position: absolute;
    top: 45%;
    left: 45%;
    z-index: 9999;
}
.exportmsg {
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 10000;
    position: absolute;
    top: 48vh;
    left: 55vh;
    font-size: 22px;
    color: rgb(243, 62, 62);
}
#search-custStatic-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;

    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }

    .search-item-dialog {
        width: 340px;
        height: auto;

        .dialog-footer {
            text-align: right;
        }

        .el-form-item {
            margin-bottom: 0;
        }
    }

    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
</style>